import React from "react";
import { Box, Inline } from "@origin-digital/ods-core";
import PermissionsControlledWrapper from "src/components/Permissions/PermissionsControlledWrapper";
import { PermissionEnum } from "src/components/Permissions/types";
import { useResponsiveBelowSm } from "src/hooks";
import { AsyncButtonProps } from "src/components/AsyncButton/types";
import { AsyncButton } from "src/components/AsyncButton";

interface PermissionsActionButtonsProps {
  primaryButtonProps?: AsyncButtonProps<void>;
  secondaryButtonProps?: AsyncButtonProps<void>;
  isInternet?: boolean;
  showSecondaryButton?: boolean;
}

const PermissionsActionButtons: React.FC<PermissionsActionButtonsProps> = ({
  primaryButtonProps,
  secondaryButtonProps,
  isInternet,
  showSecondaryButton = true,
}) => {
  const isBelowSm = useResponsiveBelowSm();

  const enhancedPrimaryButtonProps = React.useMemo(() => {
    if (!primaryButtonProps?.onHandleClick) return null;

    return {
      ...primaryButtonProps,
      fullWidth: {
        xs: true,
        sm: false,
      } as const,
      children: isInternet ? (
        <Inline>{isBelowSm ? "Update" : "Update Internet"}</Inline>
      ) : (
        <Inline>{isBelowSm ? "Lodge" : "Lodge request"}</Inline>
      ),
    };
  }, [primaryButtonProps, isBelowSm, isInternet]);

  const enhancedSecondaryButtonProps = React.useMemo(() => {
    if (!secondaryButtonProps?.onHandleClick) return null;

    return {
      ...secondaryButtonProps,
      fullWidth: {
        xs: true,
        sm: false,
      } as const,
      variant: "outlined" as const,
      children: "Save draft",
    };
  }, [secondaryButtonProps, showSecondaryButton]);

  return (
    <PermissionsControlledWrapper
      requiredPermission={PermissionEnum.CREATE_REQUEST}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        gap="medium"
      >
        {enhancedPrimaryButtonProps && (
          <AsyncButton {...enhancedPrimaryButtonProps} />
        )}
        {enhancedSecondaryButtonProps && showSecondaryButton && (
          <AsyncButton {...enhancedSecondaryButtonProps} />
        )}
      </Box>
    </PermissionsControlledWrapper>
  );
};

export default PermissionsActionButtons;
